import React from "react";
import { Post } from "../types/Post";
import { css } from "styled-components";
import { Title } from "../typography";
import { getImageUrl } from "../helpers/getImageUrl";
import { Hr } from "./Hr";
import { Colors } from "../branding";
import { Column, Spacing } from "../helpers/layout";
import { useResponsive } from "../context/ResponsiveContext";
import { PostNavigation } from "./PostNavigation";

export function PostCover(props: { post: Post }) {
  const { post } = props;
  const { isMobile, isTablet } = useResponsive();
  const coverImage = isMobile
    ? getImageUrl(post.cover_image_mobile, {
        width: 400,
      })
    : isTablet
    ? getImageUrl(post.cover_image_tablet, {
        width: 1024,
      })
    : getImageUrl(post.cover_image_desktop, {
        width: "large",
      });

  const isSmall = isMobile || isTablet;

  return (
    <>
      <div
        css={css`
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 34%;
          background: url(${coverImage});
          background-size: cover;
          background-position: 50%;

          ${isMobile &&
          css`
            padding-bottom: 100%;
          `}
        `}
      >
        {!isSmall && (
          <div
            css={css`
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              color: ${Colors.white};
              text-align: center;
            `}
          >
            <div>
              <Column gutter={Spacing.l}>
                <Title>{post.name}</Title>
                <Hr size="large" color={Colors.white} align="center" />
                <div
                  css={css`
                    width: 100%;
                    max-width: 400px;
                    margin: 0 auto;
                  `}
                >
                  <p>{post.slogan}</p>
                </div>
              </Column>
            </div>
          </div>
        )}
      </div>
      {isSmall && <PostNavigation post={post} />}
      {isSmall && (
        <div
          css={css`
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${Colors.black};
            text-align: center;
            padding: ${Spacing.xl} ${Spacing.l};
            box-sizing: border-box;
          `}
        >
          <div>
            <Column gutter={Spacing.l}>
              <Title>{post.name}</Title>
              <Hr size="large" color={Colors.black} align="center" />
              <div
                css={css`
                  width: 100%;
                  max-width: 400px;
                  margin: 0 auto;
                `}
              >
                <p>{post.slogan}</p>
              </div>
            </Column>
          </div>
        </div>
      )}
      {!isSmall && <PostNavigation post={post} />}
    </>
  );
}
